import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
// import DatePicker from "react-datepicker";
// import DateTimePicker from 'react-datetime-picker';
import { TimePicker } from "react-tempusdominus-bootstrap";
const getFieldCSSClasses = (touched, errors) => {
    const classes = ["form-control timePicker"];
    if (touched && errors) {
        classes.push("is-invalid");
    }

    if (touched && !errors) {
        classes.push("is-valid");
    }

    return classes.join(" ");
};

export function TimePickerField({ ...props }) {
    const { setFieldValue, errors, touched } = useFormikContext();
    const [field] = useField(props);
    const [minDateVal, setMinDateVal] = useState("");

    const UpdateValue = (value) => {
        console.log(field);
        console.log(value);
        if(field.value !== undefined){
            setFieldValue(field.name, value.date);
        }
        // setFvalue(value);
        if (props.onSelect) {
            console.log(value);
        // //   const item = searchData[props.source].find(item => item._id === value);
          props.onSelect(value.date);
        }
    }

    useEffect(() => {
        if (props?.placeholder) {
            const parentElement = document.querySelector('.timepicker');
            if (parentElement) {
                const inputElement = parentElement.querySelector('.datetimepicker-input');
                if (inputElement) {
                console.log("inputElement", inputElement);
                inputElement.setAttribute("placeholder", props.placeholder || "Select a time");
                }
            }
        }
    }, [props.placeholder])
    
    return (
        <>
            {props.label && <label>{props.label}</label>}
            <TimePicker
                format={props.format ? props.format : 'hh:mm a'}
                onChange={val => UpdateValue(val)}
                date={props.time ? props.time : (field.value || null)}
                minDate={props.minDate || false}
                maxDate={props.maxDate ? props.maxDate : false}
                readOnly={props.readOnly ? props.readOnly : false}
            // className={getFieldCSSClasses(touched[field.name], errors[field.name])}
            // style={{ width: "100%" }}
            // isClearable
            // showTimeSelect
            // showTimeSelectOnly
            // timeIntervals={15}
            // {...field}
            // {...props}
            // selected={(field.value && new Date(field.value)) || null}
            // onChange={val => {
            //     setFieldValue(field.name, val);
                // }}
                className="timepicker"
            />
            {errors[field.name] && touched[field.name] ? (
                <div className="invalid-datepicker-feedback">
                    {errors[field.name].toString()}
                </div>
            ) : (
                null
                // <div className="feedback">
                //     Please enter <b>{props.label}</b> in 'HH:MM A' format
                // </div>
            )}
        </>
    );
}